// Configurable axios timeout for POST requests (milliseconds)
// Set VITE_AXIOS_POST_TIMEOUT_MS in your environment to override the default.
export const AXIOS_POST_TIMEOUT_MS = Number(import.meta.env.VITE_AXIOS_POST_TIMEOUT_MS) || 29000;
